import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-checked", "disabled", "onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Finance", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Full-Service Lease", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "tb-fsl-loader" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lds-roller" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { computed, onMounted } from 'vue';
	import { useStore } from 'vuex';
	import { EFinaceToggleTypes } from '@/enums';
	import { IDataLayerItem, IDataLayerItemItem, IStoreState } from '@/types';
	import { getCookie } from '@/helpers';

	
export default /*#__PURE__*/_defineComponent({
  name: 'DetailHeaderFSLToggle',
  setup(__props) {

	const store = useStore<IStoreState>();
	
	const selectedFinanceType = computed((): EFinaceToggleTypes => store.state.DetailApp.selectedFinanceType);
	const isFsl = computed((): boolean => selectedFinanceType.value == EFinaceToggleTypes.fsl);
	const isLoading = computed((): boolean => store.state.DetailApp.isFslLoading); 

	const handleButtonClick = (): void => {
		store.commit('DetailApp/setSelectedFinanceType', isFsl.value ? EFinaceToggleTypes.finance : EFinaceToggleTypes.fsl);
		setSelectedCookie();
		sendAnalytics();
	};
	const sendAnalytics = (): void => {
		const dl: Array<IDataLayerItem> = (window as any).dataLayer || [];
		const vehicle_arr: Array<IDataLayerItemItem> = dl.filter(o => o.event == 'view_item').flatMap(o => o.items || []);

		const new_toggle_state = isFsl.value ? 'full service lease' : 'finance';
		const has_tpr_applied = getCookie('tprguid') ? 'True' : 'False';
		const tpr_case_id = getCookie('tprcaseid');
		const vehicle_model = vehicle_arr.length ? vehicle_arr[0].item_category2 : ''; 
		const vehicle_grade = vehicle_arr.length ? vehicle_arr[0].item_category3 : '';
		
		dl.push({
			event: "toggle",
			toggle_name: "Full Service Lease",
			new_toggle_state,
			has_tpr_applied,
			page_type: "New Vehicle Inventory Details Page",
			tpr_case_id,
			vehicle_franchise: "Toyota",
			vehicle_model,
			vehicle_grade,
			filters: []
		});
	};
	const setSelectedCookie = () => {
		const dateexp = new Date();
		dateexp.setDate(dateexp.getDate() + 400);//chrome limit apparently.
		const expires = "expires="+ dateexp.toString();
		const cookieData = ";" + expires + ';path=/';
		document.cookie = "selectedFinanceType=" + selectedFinanceType.value + cookieData;
	}

	onMounted(() => {
		const availableFinanceTypes = (window as any).AvailableFinanceTypes || [];
		const preferredFinanceType = getCookie('selectedFinanceType') || '';
		const defaultFinanceType = (window as any).DefaultFinanceType || '';
		const initialFinanceType = preferredFinanceType && availableFinanceTypes.includes(preferredFinanceType) ? preferredFinanceType : defaultFinanceType;
		const selected = initialFinanceType || EFinaceToggleTypes.finance;
		store.commit('DetailApp/setSelectedFinanceType', selected);
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "tb-fsl-toggle",
    role: "switch",
    "aria-label": "View Full Service Lease instead of finance",
    "aria-checked": _unref(isFsl),
    disabled: _unref(isLoading),
    onClick: _withModifiers(handleButtonClick, ["prevent"])
  }, _hoisted_5, 8, _hoisted_1))
}
}

})